import { memo } from "react";
import { Form, InputGroup } from "react-bootstrap";
import { Controller } from "react-hook-form";

const HookInput = ({
  key,
  label,
  inputType,
  rules = {},
  name,
  control,
  errors,
  placeholder = "",
  addons,
}) => {
  const ruleNames = Object.keys(rules);
  return (
    <>
      {label && <Form.Label>{label}</Form.Label>}
      <Controller
        name={name}
        control={control}
        rules={rules}
        render={({ field, ref, fieldState: { invalid } }) => (
          <InputGroup>
            <Form.Control
              key={key}
              type={inputType}
              {...field}
              ref={ref}
              isInvalid={invalid}
              placeholder={placeholder || ""}
            />
            {addons}
          </InputGroup>
        )}
        defaultValue=""
      />
      {errors &&
        ruleNames.map(
          (rule, index) =>
            errors[name] &&
            errors[name].type === rule && (
              <span
                className="form__validation-message"
                key={`${index}_${rule}`}
              >
                {errors[name].message}
              </span>
            )
        )}
    </>
  );
};

export default memo(HookInput);
